import {BaseConverter} from '../../base/converters/base-converter.converter';
import {ProductModel} from '../models/product.model';
import {Product} from '../../shared/DTO/product';
import {IdentityConverter} from './identity.converter';
import {ProductTypeConverter} from './product-type.converter';
import {ContactConverter} from './contact.converter';
import {BasicProductConverter} from './basic-product.converter';
import {Injectable} from '@angular/core';
import * as moment from 'moment';
import {BasicProperty1Converter} from './properties.converter';

@Injectable()
export class ProductConverter extends BaseConverter<ProductModel, Product> {

  constructor(private identityConverter: IdentityConverter,
              private productTypeConverter: ProductTypeConverter,
              private contactConverter: ContactConverter,
              private basicProductConverter: BasicProductConverter,
              private basicProperty1Converter: BasicProperty1Converter
  ) {
    super();
  }

  convertToDto(model: ProductModel): Product {
    if (!model) {
      return;
    }
    return {
      invoiceExpirationDate: model.invoiceExpirationDate?.toISOString() || undefined,
      expirationDate: model.expirationDate?.toISOString() || undefined,
      activationDate: model.activationDate?.toISOString() || undefined,
      properties: this.basicProperty1Converter.convertToDtoList(model.properties),
      unit: model.unit,
      accountCode: model.accountCode,
      alias: model.alias,
      certifiedEmail: model.certifiedEmail,
      contacts: this.contactConverter.convertToDtoList(model.contacts),
      customerCode: model.customerCode,
      description: model.description,
      duration: model.duration,
      identity: this.identityConverter.convertToDto(model.identity),
      management: model.management,
      massive: model.massive,
      orderId: model.orderId,
      productType: this.productTypeConverter.convertToDto(model.productType),
      state: model.state,
      subProducts: this.basicProductConverter.convertToDtoList(model.subProducts),
      urlRedirect: model.urlRedirect,
      userId: model.userId
    };
  }

  convertToModel(dto: Product): ProductModel {
    if (!dto) {
      return null;
    }
    let model: ProductModel = new ProductModel();
    model.userId = dto.userId;
    model.activationDate = dto.activationDate ? moment(dto.activationDate) : null;
    model.accountCode = dto.accountCode;
    model.alias = dto.alias;
    model.certifiedEmail = dto.certifiedEmail;
    model.contacts = this.contactConverter.convertToModelList(dto.contacts);
    model.customerCode = dto.customerCode;
    model.description = dto.description;
    model.duration = dto.duration;
    model.expirationDate = dto.expirationDate ? moment(dto.expirationDate) : null;
    model.identity = this.identityConverter.convertToModel(dto.identity);
    model.invoiceExpirationDate = dto.invoiceExpirationDate ? moment(dto.invoiceExpirationDate) : null;
    model.management = dto.management;
    model.massive = dto.massive;
    model.orderId = dto.orderId;
    model.properties = this.basicProperty1Converter.convertToModelList(dto.properties);
    model.productType = this.productTypeConverter.convertToModel(dto.productType);
    model.state = dto.state;
    model.subProducts = this.basicProductConverter.convertToModelList(dto.subProducts);
    model.unit = dto.unit;
    model.urlRedirect = dto.urlRedirect;

    return model;
  }

}
